import { ViewBlockHeader } from "./ViewBlockHeader";
import { Box, Divider } from "@mui/material";
import BlockItem from "./BlockItem";
import { useGetTemplateInfoByIdQuery } from "@callveriq/redux/services/settings/auditManager.service";
import { useParams } from "react-router-dom";
import {
    getParameterResponseOptions,
    getParameters,
    isDefined,
} from "@callveriq/utils/helper/common.helper";
import useNodeContext from "../../../hooks/useNodeContext";
import SkeletonLoader from "@callveriq/components/custom_components/Loader/SkeletonLoader";
import EmptyState from "@callveriq/components/custom_components/reuseable/EmptyState";
import EmptyDataSvg from "@callveriq/components/svg/EmptyDataSvg";
import { ParameterBlockFormType } from "../../../../types/bert";
import ParameterSvg from "../../../svg/ParameterSvg";

const Parameter = () => {
    const { template_id, parameter_id } = useParams<{
        template_id: string;
        parameter_id: string;
    }>();
    const { data, isLoading } = useGetTemplateInfoByIdQuery(
        { template_id: +template_id!, questions: "all" },
        {
            skip: !isDefined(template_id),
        }
    );

    const { nodeDataToUpdate: parameter } = useNodeContext() as {
        nodeDataToUpdate: ParameterBlockFormType;
    };

    const allParameters = getParameters(data)
        .filter((e) => e.id !== +parameter_id!)
        .filter((e) => e.question_type !== "none");

    const selectedParameter =
        allParameters?.filter((e) => e.id === parameter?.parameter)?.[0]
            ?.question_text ?? null;

    const reposneOptions =
        getParameterResponseOptions(
            allParameters.find((e) => e.id === parameter.parameter)
        ) ?? [];

    if (isLoading) {
        return (
            <div>
                <ViewBlockHeader icon={<ParameterSvg />} title="Parameter" />
                <SkeletonLoader />
            </div>
        );
    }
    if (!parameter) {
        return (
            <EmptyState
                Component={<EmptyDataSvg />}
                text="No Parameter Found!"
            />
        );
    }
    return (
        <div>
            <ViewBlockHeader icon={<ParameterSvg />} title="Parameter" />
            <Box
                className="flex flex-col "
                sx={{
                    p: 2,
                    gap: 1.5,
                }}
            >
                <BlockItem title="Block Name" value={parameter.name} />
                <Divider />
                <BlockItem
                    title="Selected Parameter"
                    value={selectedParameter}
                />
                <Divider />
                <BlockItem
                    title="Selected Response"
                    value={
                        reposneOptions.find(
                            (res) => res.id === parameter.response
                        )?.label
                    }
                />
            </Box>
        </div>
    );
};

export default Parameter;
